import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class FechamentoFinanceiroService {

  constructor(private http: HttpClient) {
  }

  consultarFechamentosComPaginacao(tipoFiltro: number, status: number[], paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idFornecedor?: number, inicio?: Date, fim?: Date) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoFiltro', tipoFiltro? tipoFiltro.toString(): '0')
      .set('status', status.toString())
      .set('idFornecedor', idFornecedor ? idFornecedor.toString() : '')
      .set('inicio', inicio ? inicio.toISOString() : '')
      .set('fim', fim ? fim.toISOString() : '');

    if (idFornecedor) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/ListaPag',
      {
        params: parametros
      });
  }

  consultarPedidosDoFechamento(idFechamento: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/BuscarPedidosDoFechamento',
      { params: new HttpParams().set('idFechamento', idFechamento.toString()) });
  }

  consultarPedidosParaFechar(idFornecedor: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/BuscarPedidosParaFechar',
      { params: new HttpParams().set('idFornecedor', idFornecedor.toString()) });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  consultarProdutosDoPedido(idCupom: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/BuscarProdutosDoPedido',
      { params: new HttpParams().set('idCupom', idCupom.toString()) });
  }

  consultarProdutosDoFechamento(idFechamento: number) {
    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/BuscarProdutosDoFechamento',
      { params: new HttpParams().set('idFechamento', idFechamento.toString()) });
  }

  salvar(fechamento: FormData) {
    return this.http.post(globals.apiUrl + '/api/FechamentoFinanceiro/Salvar', fechamento);
  }

  alterarStatusDoFechamento(idFechamento: number, idStatus: number ) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('idFechamento', idFechamento.toString());
    queryParams = queryParams.append('status', idStatus.toString());

    return this.http.get<any>(globals.apiUrl + '/api/FechamentoFinanceiro/AlterarStatus',
      { params: queryParams } );
  }

  exportarPedidosParaFechar(idFornecedor: number) {
    return this.http.get(globals.apiUrl + '/api/FechamentoFinanceiro/ExportarPedidosParaFechar',
      { responseType: 'blob', params: new HttpParams().set('idFornecedor', idFornecedor.toString()) });
  }

  exportarConsultaFechamento(tipoFiltro: number, status: number[], paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idFornecedor?: number, inicio?: Date, fim?: Date) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoFiltro', tipoFiltro? tipoFiltro.toString(): '0')
      .set('status', status.toString())
      .set('idFornecedor', idFornecedor ? idFornecedor.toString() : '')
      .set('inicio', inicio ? inicio.toISOString() : '')
      .set('fim', fim ? fim.toISOString() : '');

    if (idFornecedor) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    return this.http.get(globals.apiUrl + '/api/FechamentoFinanceiro/ExportarFechamentos',
      { responseType: 'blob', params: parametros }
    );
  }
}
